// extracted by mini-css-extract-plugin
module.exports = {"container":"InterestDisclosurePage_container__3R1Ta","close":"InterestDisclosurePage_close__WocjV"};